'use client';

import { styled } from 'styled-components';

/** Shared by the desktop dropdown and the mobile drawer. */
export const PillarCategory = styled.p<{ $accentColor: string }>`
  align-items: center;
  color: ${(props) => props.$accentColor};
  display: flex;

  /** custom per design */
  font-family: var(--font-walsheim);
  font-size: ${({ theme }) => theme.typography.fontSize.bodySm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.link};
  gap: ${({ theme }) => theme.spacing[0.5]};
  line-height: ${({ theme }) => theme.typography.lineHeight.headingFive};
  margin-block: 0 ${({ theme }) => theme.spacing[0.5]};
`;
